@if (!mode) {
  @switch (template) {
    @case ('external') {
      <a [attr.download]="download ? 'download' : null" class="-external" [href]="to" target="_blank" rel="noopener noreferrer" [attr.disabled]="disabled">
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <icon class="-xsm" icon="external-link"></icon>
      </a>
    }
    @case ('newTab') {
      <a [attr.download]="download ? 'download' : null" class="-external" [routerLink]="to" target="_blank" rel="noopener noreferrer" [attr.disabled]="disabled">
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <icon class="-xsm" icon="external-link"></icon>
      </a>
    }
    @case ('internal') {
      @if (!redirectViaServer) {
        <a [routerLink]="url" [queryParams]="tree.queryParams" [fragment]="tree.fragment" [attr.disabled]="disabled">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
      }
      @if (redirectViaServer) {
        <a [href]="url" [attr.disabled]="disabled">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
      }
    }
    @case ('falseInternal') {
      <a [href]="to">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }
    @case ('noRoute') {
      <a [class]="display" [attr.disabled]="disabled">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }
  }
}

@if (mode && mode === 'requestnow') {
  <a [class]="display">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (requestnowProcessing) {
      <icon icon="refresh" class="-refresh -infinite-spin -xsm -colorPrimaryGreen" ></icon>
    }
    @if (requestnowProcessing === false) {
      <icon icon="checkmark" class="-refresh -xsm -colorPrimaryGreen" ></icon>
    }
  </a>
}

@if (mode && mode === 'getapikey') {
  <a [class]="display">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
